export default __webpack_public_path__ + "static/media/layer2.31fb332b.svg";